document.addEventListener('DOMContentLoaded', () => {
    // main menu toggle
    for (const el of document.querySelectorAll('.open-menu-main')) {
        el.addEventListener('click', () => {
            document.body.classList.toggle('menu-main-open')
        })
    }

    // for (const el of document.querySelectorAll('.close-menu-main')) {
    //     el.addEventListener('click', () => {
    //         document.body.classList.remove('menu-main-open')
    //     })
    //     el.addEventListener('keypress', (e) => {
    //         if (['Enter', 'Space'].includes(e.code)) {
    //             document.body.classList.remove('menu-main-open')
    //         }
    //     })
    // }

    // main menu submenu toggle
    for (const el of document.querySelectorAll('.main-menu .has-children')) {
        el.addEventListener('click', (e) => {
            if (!e.target.classList.contains('label')) {
                e.stopPropagation()
                for (const open of document.querySelectorAll(
                    '.main-menu .has-children.open'
                )) {
                    if (open !== el && !open.contains(el))
                        open.classList.remove('open')
                }
                el.classList.toggle('open')
            }
        })
    }
})
